import React, { useState, useReducer, useEffect, useContext } from "react";
import classes from "./Feedback.module.css";
import styles from "./RatingsandFeedback.module.css";
import { Input } from "../../Utility";
import { getCompanyFolderName, getUserFolderName } from "../../../../Utility";
import "./style.css";
import { toast } from "react-toastify";
import axios from "../../../../Axios";
import { Urls } from "../../../../Urls";
import { Activity, currentRequestTimeStamp } from "../../../../Constants";
import Axios from "axios";
import mixpanel from "mixpanel-browser";
import Loader from "../../../Loader";
import { validateAndReadFile } from "../../../CompanyProfileNew/FreightMaster/Utility/utility";
import { MyCompanyProfileContext } from "../../../../MyCompanyProfileContext";
import { useMixPanelForTracking } from "../../../../utils/TrackMixPanel";
import { UserApiContext } from "../../../UserDetailsContext/UserDetailsContext";
import useViewOnlyAccess from "../../../../hooks/useViewOnlyAccess";

const RatingsandFeedback = ({
  editMode = false,
  tncRef,
  saveButtonText = "Submit & Save Report",
  from = "",
  onsubmit = "",
  company_id = "",
  notnc = true,
  onClose,
  dropDownSelect = "",
  isSuperAdmin = false,
  setQualitativeInputs,
  qualitativeInputs = {},
  buttonID,
  goToStart,
  getSessionDetails = "",
  toggleLoader,
  setUserData,
  selectedOrg,
  setSelectedOrg,
  setOrgList,
  orgList,
  tncData,
}) => {
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const { userDetails, companyProfile } = useContext(UserApiContext);
  const { noAccess: tncNoAccess } = useViewOnlyAccess("terms_conditions", "lorri_terms_conditions", true);
  const [userInput, setUserInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      overall_rating: 0,
      contracted_terms: false,
      policy_terms: "",
      insurance: "",
      fuel_clause: "",
      shortage_clause: "",
      detention_charges: "",
      damages_clause: "",
      service_level_adherence_clause: "",
      insured_amount: "",
      benchmark_unseen: true,
      comments: "",
      save_company_profile: false,
    }
  );
  const [userInput2, setUserInput2] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      overall_rating: 0,
      contracted_terms: false,
      policy_terms: "",
      insurance: "",
      fuel_clause: "",
      shortage_clause: "",
      detention_charges: "",
      damages_clause: "",
      service_level_adherence_clause: "",
      insured_amount: "",
      benchmark_unseen: true,
      comments: "",
      save_company_profile: false,
    }
  );
  const [attachments, setattachments] = useState([]);
  // const [saveincompanyprofile, setSaveincompanyprofile] = useState(false)
  const handleChange = (key, value) => {
    setUserInput({ [key]: value });
    if (setQualitativeInputs) {
      const updatedInput = { ...userInput, [key]: value };
      setQualitativeInputs({
        contracted_terms: { value: updatedInput.contracted_terms },
        policy_terms: { value: updatedInput.policy_terms },
        insurance: { value: updatedInput.insurance },
        insured_amount: {
          value: updatedInput.insurance === "yes" ? updatedInput.insured_amount : "",
        },
        fuel_clause: { value: updatedInput.fuel_clause },
        detention_charges: { value: updatedInput.detention_charges },
        shortage_clause: { value: updatedInput.shortage_clause },
        damages_clause: { value: updatedInput.damages_clause },
        uploaded_files: qualitativeInputs.uploaded_files || { user_files: [] },
        comments: { value: updatedInput.comments },
        save_company_profile: { value: updatedInput.save_company_profile },
      });
    }
  };
  // console.log(company_id)
  const { TrackMixPanel } = useMixPanelForTracking(
    userDetails,
    companySettingData
  );
  const [showLoader, setShowLoader] = useState(false);
  
  useEffect(() => {
    let newData = {
      contracted_terms:
        qualitativeInputs.contracted_terms &&
          qualitativeInputs.contracted_terms.value
          ? qualitativeInputs.contracted_terms.value
          : false,
      overall_rating:
        qualitativeInputs.benchmark_rating &&
          qualitativeInputs.benchmark_rating.value
          ? qualitativeInputs.benchmark_rating.value.overall_rating
          : 0,
      policy_terms: qualitativeInputs.policy_terms
        ? qualitativeInputs.policy_terms.value
        : "",
      insurance: qualitativeInputs.insurance
        ? qualitativeInputs.insurance.value
        : "",
      insured_amount: qualitativeInputs.insured_amount
        ? qualitativeInputs.insured_amount.value
        : "",
      fuel_clause: qualitativeInputs.fuel_clause
        ? qualitativeInputs.fuel_clause.value
        : "",
      detention_charges: qualitativeInputs.detention_charges
        ? qualitativeInputs.detention_charges.value
        : "",
      damages_clause: qualitativeInputs.damages_clause
        ? qualitativeInputs.damages_clause.value
        : "",
      shortage_clause: qualitativeInputs.shortage_clause
        ? qualitativeInputs.shortage_clause.value
        : "",
      service_level_adherence_clause:
        qualitativeInputs.service_level_adherence_clause
          ? qualitativeInputs.service_level_adherence_clause.value
          : "",
      benchmark_unseen: qualitativeInputs.benchmark_unseen
        ? qualitativeInputs.benchmark_unseen
        : true,
      uploaded_files: qualitativeInputs.uploaded_files
        ? qualitativeInputs.uploaded_files.user_files
        : "",
      comments: qualitativeInputs.comments
        ? qualitativeInputs.comments.value
        : "",
      save_company_profile:
        qualitativeInputs.save_company_profile &&
          qualitativeInputs.save_company_profile.value
          ? qualitativeInputs.save_company_profile.value
          : false,
    };
    setUserInput2(newData);
  }, []);

  useEffect(() => {
    let newData = {
      contracted_terms:
        qualitativeInputs.contracted_terms &&
          qualitativeInputs.contracted_terms.value
          ? qualitativeInputs.contracted_terms.value
          : false,
      overall_rating:
        qualitativeInputs.benchmark_rating &&
          qualitativeInputs.benchmark_rating.value
          ? qualitativeInputs.benchmark_rating.value.overall_rating
          : 0,
      policy_terms: qualitativeInputs.policy_terms
        ? qualitativeInputs.policy_terms.value
        : "",
      insurance: qualitativeInputs.insurance
        ? qualitativeInputs.insurance.value
        : "",
      insured_amount: qualitativeInputs.insured_amount
        ? qualitativeInputs.insured_amount.value
        : "",
      fuel_clause: qualitativeInputs.fuel_clause
        ? qualitativeInputs.fuel_clause.value
        : "",
      detention_charges: qualitativeInputs.detention_charges
        ? qualitativeInputs.detention_charges.value
        : "",
      damages_clause: qualitativeInputs.damages_clause
        ? qualitativeInputs.damages_clause.value
        : "",
      shortage_clause: qualitativeInputs.shortage_clause
        ? qualitativeInputs.shortage_clause.value
        : "",
      service_level_adherence_clause:
        qualitativeInputs.service_level_adherence_clause
          ? qualitativeInputs.service_level_adherence_clause.value
          : "",
      benchmark_unseen: qualitativeInputs.benchmark_unseen
        ? qualitativeInputs.benchmark_unseen
        : true,
      uploaded_files: qualitativeInputs.uploaded_files
        ? qualitativeInputs.uploaded_files.user_files
        : "",
      comments: qualitativeInputs.comments
        ? qualitativeInputs.comments.value
        : "",
      save_company_profile:
        qualitativeInputs.save_company_profile &&
          qualitativeInputs.save_company_profile.value
          ? qualitativeInputs.save_company_profile.value
          : false,
    };
    // console.log(newData,'newData')
    setUserInput(newData);
  }, [qualitativeInputs]);

  const attachAttachments = async (event) => {
    const result = await validateAndReadFile(event.target.files[0], [
      "excel",
      "image",
      "pdf",
    ]);

    if (result.error) {
      toast.error(result.error);
      return false;
    }

    setattachments(event.target.files);

    if (setQualitativeInputs) {
      setQualitativeInputs({
        contracted_terms: { value: userInput.contracted_terms },
        policy_terms: { value: userInput.policy_terms },
        insurance: { value: userInput.insurance },
        insured_amount: {
          value: userInput.insurance === "yes" ? userInput.insured_amount : "",
        },
        fuel_clause: { value: userInput.fuel_clause },
        detention_charges: { value: userInput.detention_charges },
        shortage_clause: { value: userInput.shortage_clause },
        damages_clause: { value: userInput.damages_clause },
        uploaded_files: { user_files: Array.from(event.target.files).map(f => ({ fileName: f.name, filePath: "" })) },
        comments: { value: userInput.comments },
        save_company_profile: { value: userInput.save_company_profile },
      });
    }
  };
  const downloadAttachments = (e, attachments) => {
    attachments.map((file) => {
      let body = {
        action: "download",
        accountName: "lnclientdata",
        containerName: "benchmark-data",
        fileName: file["filePath"],
      };
      Axios.post(Urls.fileService, body)
        .then((res) => {
          // console.log(res.data)
          window.open(res.data.url, "_blank");
        })
        .catch((error) => {
          console.error(error);
          toast.error("Error while downloading attachments");
        });
    });
  };
  const FeedbackInputsIndependent = [
    {
      label: "Fuel Clause",
      value: "fuel_clause",
      mandatory: false,
      height: "sm",
      tag: "textarea",
    },
    {
      label: "Detention Charges",
      value: "detention_charges",
      mandatory: false,
      height: "sm",
      tag: "textarea",
    },
    {
      label: "Damages",
      value: "damages_clause",
      mandatory: false,
      height: "sm",
      tag: "textarea",
    },
    {
      label: "Shortages",
      value: "shortage_clause",
      mandatory: false,
      height: "sm",
      tag: "textarea",
    },
    {
      label: "Comments",
      value: "comments",
      mandatory: false,
      tag: "textarea",
      height: "sm",
    },
    // {
    //     label: 'Service Level Adherence (SLA)',
    //     value: 'service_level_adherence_clause',
    //     mandatory: false,
    //     tag: 'text'
    // }
  ];
  const paymentOpions1 = [
    { label: "Advance Payment", value: "Advance Payment" },
    {
      label: "Immediate (on delivery of cargo and submission of POD)",
      value: "Immediate",
    },
    { label: "15 days", value: "15 days" },
    { label: "30 days", value: "30 days" },
    { label: "45 days", value: "45 days" },
    { label: "60 days", value: "60 days" },
    // {label:"As per contracted Terms", value:"As per contracted Terms"}
  ];
  // const paymentOpions = [
  //     <option value="" disabled>Select Payment Term</option>,
  //     <option value="Advance Payment">Advance Payment</option>,
  //     <option value="Immediate (on delivery of cargo and submission of POD)">Immediate (on delivery of cargo and submission of POD)</option>,
  //     <option value="15 days">15 days</option>,
  //     <option value="30 days">30 days</option>,
  //     <option value="45 days">45 days</option>,
  //     <option value="60 days">60 days</option>,
  // ]
  const insuredamountoptions1 = [
    { label: "Cut off < INR 50k", value: "Cut off < INR 50k" },
    { label: "Cut off < INR 5 lakhs", value: "Cut off < INR 5 lakhs" },
    { label: "Cut off < INR 20 lakhs", value: "Cut off < INR 20 lakhs" },
    // {label:'As per contracted Terms', value:"As per contracted Terms"}
  ];
  // const insuredamountoptions = [
  //     <option value="" disabled>Select Insured Amount</option>,
  //     <option value="Cut off < INR 50k">{`Cut off < INR 50k`}</option>,
  //     <option value="Cut off < INR 5 lakhs">{`Cut off < 5 lakhs`}</option>,
  //     <option value="Cut off < INR 20 lakhs"> {`Cut off < 20 lakhs`}</option>,
  // ]

  const uploadAttachments = function () {
    let userFiles = [];
    for (let i = 0; i < attachments.length; i++) {
      userFiles.push({
        filePath: `company/${getCompanyFolderName(userDetails.email)}/${getUserFolderName(userDetails.email, companyProfile?.domain_data?.company_id)}/${userDetails?.user_id}-${attachments[i]["name"].replace(/ /g, "-")}`,
        fileName: attachments[i]["name"],
        fileData: attachments[i],
      });
    }

    return new Promise((resolve, reject) => {
      if (userFiles.length > 0) {
        // Upload files to storage
        let totalFilesUploaded = 0;
        let totalFilesToUpload = userFiles.length;
        userFiles.map((file) => {
          let body = {
            fileName: file["filePath"],
            accountName: "lnclientdata",
            containerName: "benchmark-data",
            action: "upload",
          };
          // console.log(file['fileData'])
          Axios.post(Urls.fileService, body)
            .then((res) => {
              // Call `PUT` request for uploading file to storage with url recieved from API
              Axios.put(res.data.url, file["fileData"], {
                headers: {
                  "x-ms-blob-type": "blockblob",
                  "x-ms-blob-content-disposition": file["fileData"]["type"],
                },
              })
                .then((res) => {
                  totalFilesUploaded += 1;
                  if (totalFilesUploaded === totalFilesToUpload) {
                    toast.success("Attachments uploaded");
                    resolve({
                      status: "success",
                    });
                  }
                })
                .catch((error) => {
                  toast.error("Error while uploading your attachments");
                  console.log(error);
                });
            })
            .catch((error) => {
              console.log(error);
              reject({
                status: "failed",
                message: error,
              });
            });
        });
      } else {
        resolve({
          status: "success",
        });
      }
    });
  };

  const submithandler = () => {
    Activity([
      {
        screen: "Update Terms & Condition",
        module: "Update Terms & Condition",
        user_activity: `${saveButtonText} button Clicked`,
        timestamp: currentRequestTimeStamp()
        , "userEmail": userDetails?.email, "userName": userDetails?.user_name
        , companyname: userDetails.company_name ? userDetails.company_name : userDetails.email ? userDetails.email.split("@")[1].split(".")[0] : ""
      },
    ]);
    TrackMixPanel({
      ModuleName: "lorri spot",
      ScreenName: "my enquiries - terms and conditions",
      Data: `contracted terms: ${userInput.contracted_terms},
                        payment terms: ${userInput.policy_terms},
                        insurance: ${userInput.insurance},
                        insured amount: ${userInput.insurance === "yes"
          ? userInput.insured_amount
          : ""
        },
                        fuel: ${userInput.fuel_clause},
                        detention: ${userInput.detention_charges},
                        damage: ${userInput.damages_clause},
                        shortages: ${userInput.shortage_clause}`,
      Definition:
        "user has clicked on update your terms and conditions in my enquiries",
    });

    let user_Files = [];
    for (let i = 0; i < attachments.length; i++) {
      user_Files.push({
        filePath: `company/${getCompanyFolderName(userDetails.email)}/${getUserFolderName(userDetails.email, companyProfile?.domain_data?.company_id)}/${userDetails?.user_id}-${attachments[i]["name"].replace(/ /g, "-")}`,
        fileName: attachments[i]["name"],
        fileData: attachments[i],
      });
    }

    const validateUserDetails = () => {
      // if (userInput.overall_rating === 0) {
      //     toast.error('Please Provide Your Experience rating')
      //     return 0
      // }
      if (userInput.contracted_terms) {
        return 1;
      }
      if (!userInput.policy_terms) {
        toast.error("Please enter Payment Terms");
        return 0;
      }

      if (!userInput.insurance) {
        toast.error("Please Select Insurance Availability");
        return 0;
      }
      if (userInput.insurance === "yes" && !userInput.insured_amount) {
        toast.error("Please Select Insured Amount");
        return 0;
      }
      return 1;

      // if (userInput.overall_rating >= 0 && !userInput.fuel_clause) {
      //     toast.error('Please Enter Fuel Clause')
      //     return 0
      // }
    };
    if (validateUserDetails()) {
      // let payload_data =
      // {
      //     "user_data.benchmark_rating": {
      //         "value": {
      //             overall_rating: userInput.overall_rating
      //         }
      //     },
      //     "user_data.policy_terms": {
      //         "value": userInput.policy_terms
      //     },
      //     "user_data.insurance": {
      //         "value": userInput.insurance
      //     },
      //     "user_data.insured_amount": {
      //         "value": userInput.insurance === 'yes' ? userInput.insured_amount : ''
      //     },
      //     "user_data.fuel_clause": {
      //         "value": userInput.fuel_clause
      //     },
      //     "user_data.detention_charges": {
      //         "value": userInput.detention_charges
      //     },
      //     "user_data.damages_clause": {
      //         "value": userInput.damages_clause
      //     },
      //     "user_data.service_level_adherence_clause": {
      //         "value": userInput.service_level_adherence_clause
      //     },
      //     "user_data.benchmark_unseen": {
      //         "value": false
      //     },
      //     "user_data.uploaded_files": {
      //         "user_files": user_Files
      //     }
      // }
      // toggleLoader(true)
      // axios.post(Urls.user_data, payload_data)
      //     .then(res => {
      uploadAttachments();
      //         toast.success('Terms & Conditions submitted sucessfully')
      //         // getSessionDetails()
      //         // document.getElementById("close_contactus").click()
      //         toggleLoader(false)
      //         if (onClose) {
      //             onClose()
      //         }

      //     })
      //     .catch(err => {
      //         toggleLoader(false)

      //     })
      // console.log(userInput,"SELECT");
      const newPayload = {
        company_id: company_id,
        terms_and_conditions: [
          {
            organization_id:
              selectedOrg === "" || selectedOrg == null
                ? "company"
                : selectedOrg,
            primary: {
              contracted_terms: userInput.contracted_terms,
              payment_terms: userInput.policy_terms,
              insurance: userInput.insurance,
              insured_amount:
                userInput.insurance === "yes" ? userInput.insured_amount : "",
              fuel: userInput.fuel_clause,
              detention: userInput.detention_charges,
              damage: userInput.damages_clause,
              shortages: userInput.shortage_clause,
              uploaded_files: {
                user_files: user_Files,
              },
              comments: userInput.comments,
              save_company_profile: userInput.save_company_profile,
            },
          },
        ],
      };
      newPayload["terms_and_condition"] = newPayload.terms_and_conditions;
      if (userInput.save_company_profile === true && !tncNoAccess) {
        setShowLoader(true);
        axios
          .post(Urls.companyProfile + "?field=update_tnc", {
            data: [newPayload],
          })
          .then((res) => {
            setShowLoader(false);
            if (!editMode) {
              toast.success("Terms and condition saved successfully");
            }
          })
          .catch((e) => {
            setShowLoader(false);
            console.log(e);
          });
      }
      // else{
      //     console.log(userInput2);
      //     setShowLoader(true)
      //     axios.post(Urls.companyProfile, {
      //         data: [{
      //             company_id: company_id,
      //             terms_and_conditions: [{
      //                 primary: {
      //                     contracted_terms: userInput2.contracted_terms,
      //                     payment_terms: userInput2.policy_terms,
      //                     insurance: userInput2.insurance,
      //                     insured_amount: userInput2.insurance === 'yes' ? userInput2.insured_amount : '',
      //                     fuel: userInput2.fuel_clause,
      //                     detention: userInput2.detention_charges,
      //                     damage: userInput2.damages_clause,
      //                     shortage: userInput2.shortage_clause,
      //                     uploaded_files: {
      //                         user_files : user_Files
      //                     },
      //                     comments: userInput2.comments,
      //                     save_company_profile: false,
      //                 }
      //             }]
      //         }]
      //     })
      //         .then((res) => {
      //             toggleLoader(false)
      //             setShowLoader(false)
      //         }).catch((e) => {
      //             // toggleLoader(false)
      //             setShowLoader(false)
      //             console.log(e)
      //         })
      // }
      let newData = qualitativeInputs;
      newData.contracted_terms = { value: userInput.contracted_terms };
      newData.benchmark_rating = { value: userInput.overall_rating };
      newData.policy_terms = { value: userInput.policy_terms };
      newData.insurance = { value: userInput.insurance };
      newData.insured_amount = { value: userInput.insured_amount };
      newData.fuel_clause = { value: userInput.fuel_clause };
      newData.detention_charges = { value: userInput.detention_charges };
      newData.damages_clause = { value: userInput.damages_clause };
      newData.shortage_clause = { value: userInput.shortage_clause };
      newData.service_level_adherence_clause = {
        value: userInput.service_level_adherence_clause,
      };
      newData.benchmark_unseen = { value: userInput.benchmark_unseen };
      newData.comments = { value: userInput.comments };
      newData.uploaded_files = { user_files: user_Files };
      newData.save_company_profile = { value: tncNoAccess ? false : userInput.save_company_profile };
      setQualitativeInputs({
        contracted_terms: { value: userInput.contracted_terms },
        policy_terms: { value: userInput.policy_terms },
        insurance: { value: userInput.insurance },
        insured_amount: {
          value: userInput.insurance === "yes" ? userInput.insured_amount : "",
        },
        fuel_clause: { value: userInput.fuel_clause },
        detention_charges: { value: userInput.detention_charges },
        shortage_clause: { value: userInput.shortage_clause },
        damages_clause: { value: userInput.damages_clause },
        uploaded_files: { user_files: user_Files },
        comments: { value: userInput.comments },
        save_company_profile: { value: tncNoAccess ? false : userInput.save_company_profile },
      });
      if (from === "editenquiry" && onsubmit) {
        onsubmit({
          contracted_terms: { value: userInput.contracted_terms },
          policy_terms: { value: userInput.policy_terms },
          insurance: { value: userInput.insurance },
          insured_amount: {
            value:
              userInput.insurance === "yes" ? userInput.insured_amount : "",
          },
          fuel_clause: { value: userInput.fuel_clause },
          detention_charges: { value: userInput.detention_charges },
          shortage_clause: { value: userInput.shortage_clause },
          damages_clause: { value: userInput.damages_clause },
          uploaded_files: { user_files: user_Files },
          comments: { value: userInput.comments },
          save_company_profile: { value: tncNoAccess ? false : userInput.save_company_profile },
        });
      }
      if (from !== "editenquiry") {
        const closeBtn = document.getElementById("close_contactus");
        if (closeBtn) {
          closeBtn.click();
        }
      }
    }
  };

  return (
    <div>
      {notnc ? (
        <div className={styles.notnc_container}>
          <b>
            Please update your terms and conditions in your{" "}
            <a href="\companyprofilenew\tnc" target="_blank" className={styles.notnc_link}>
              Company Profile
            </a>
          </b>
        </div>
      ) : null}
      <div className={styles.contracted_terms_container}>
        <input
          type="checkbox"
          id="contracted_terms_cb"
          className={styles.contracted_terms_checkbox}
          onChange={(e) => handleChange("contracted_terms", e.target.checked)}
          checked={
            userInput.contracted_terms ? userInput.contracted_terms : false
          }
        />
        <label htmlFor="contracted_terms_cb" className={styles.contracted_terms_label}>As per contracted Terms</label>
      </div>
      {companySettingData &&
        companySettingData?.masters_setting &&
        companySettingData?.masters_setting?.masters_show_level ===
        "organization_level" &&
        orgList &&
        orgList?.length > 0 && (
          <div
            className={styles.org_select_container}
          >
            <label className={styles.org_select_label}>Select Organization</label>
            <select
              className={`form-control ${styles.org_select}`}
              value={selectedOrg}
              onChange={(e) => dropDownSelect(e.target.value)}
            >
              {orgList &&
                orgList?.length > 0 &&
                orgList?.map((item) => (
                  <option key={item?.id} value={item?.id}>
                    {item?.name}
                  </option>
                ))}
            </select>
          </div>
        )}
      <div className={`row ${styles.row_container}`}>
        <Loader show={showLoader} />
        <div className="col-md-5">
          <label className={styles.field_label}>Payment Terms</label>
          <span className={`${classes["s-red"]}`}>*</span>
        </div>
        <div className="col-md-7">
          <Input
            tag="select"
            valueKey="policy_terms"
            userInput={userInput}
            handleChange={handleChange}
            options={paymentOpions1}
            disabled={userInput.contracted_terms}
            labelAvailable={false}
          />
        </div>
      </div>
      <div className={`row ${styles.row_container}`}>
        <div className="col-md-5">
          <label className={styles.field_label}>Cargo Insurance</label>
          <span className={`${classes["s-red"]}`}>*</span>
        </div>
        <div className="col-md-7">
          <Input
            tag="radio"
            valueKey="insurance"
            userInput={userInput}
            disabled={userInput.contracted_terms}
            labelAvailable={false}
            handleChange={handleChange}
          />
        </div>
      </div>
      {userInput.insurance === "yes" ? (
        <div className={`row ${styles.row_container}`}>
          <div className="col-md-5">
            <label className={styles.field_label}>Insured Amount</label>
            <span className={`${classes["s-red"]}`}>*</span>
          </div>
          <div className="col-md-7">
            <Input
              tag="select"
              valueKey="insured_amount"
              userInput={userInput}
              disabled={userInput.contracted_terms}
              handleChange={handleChange}
              options={insuredamountoptions1}
            />
          </div>
        </div>
      ) : null}
      {FeedbackInputsIndependent.map((item, index) => {
        return (
          <div className={`row ${item.tag === 'textarea' ? styles.row_container_textarea : styles.row_container}`} key={index}>
            <div className="col-md-5">
              <label className={item.tag === 'textarea' ? styles.textarea_label : styles.field_label}>
                {item.label}
                {item.mandatory ? (
                  <span className={`${classes["s-red"]}`}>*</span>
                ) : null}
              </label>
            </div>
            <div className="col-md-7">
              <Input
                labelAvailable={false}
                userInput={userInput}
                valueKey={item.value}
                handleChange={handleChange}
                disabled={userInput.contracted_terms}
                tag={item.tag}
                height={item?.height}
              />
            </div>
          </div>
        );
      })}

      <div className={`row ${styles.row_container_last}`}>
        <div className="col-md-5">
        </div>
        <div className="col-md-7">
          <label className={`btn btn-sm btn-primary upload-file-button-enquiry-my-account ${styles.upload_button}`}>
            <input
              type="file"
              accept="image/*,application/pdf,.xlsx,.xls"
              multiple={true}
              onChange={attachAttachments}
              className="d-none"
            />
            {attachments && attachments.length > 0 ? (
              <i className="fas fa-paperclip"></i>
            ) : (
              <><i className="fas fa-paperclip"></i> Attach files</>
            )}
          </label>
          {userInput?.uploaded_files?.length > 0 && (
            <div className={styles.attachments_container}>
              <span className={styles.attachment_name}>
                {userInput?.uploaded_files[0]?.fileName?.length > 15
                  ? `${userInput?.uploaded_files[0]?.fileName?.substring(
                    0,
                    15
                  )}...`
                  : userInput?.uploaded_files[0]?.fileName}
              </span>
              <button
                className={styles.download_button}
                onClick={(e) =>
                  downloadAttachments(e, userInput?.uploaded_files)
                }
              >
                <i className={`fa fa-download ${styles.download_icon}`} aria-hidden="true"></i>
              </button>
            </div>
          )}
        </div>
      </div>
      {isSuperAdmin ? (
        <div className={styles.save_profile_container}>
          <input
            type="checkbox"
            id="save_profile_cb"
            className={`${styles.save_profile_checkbox} ${tncNoAccess ? styles.save_profile_checkbox_disabled : styles.save_profile_checkbox_enabled}`}
            onChange={(e) =>
              handleChange("save_company_profile", e.target.checked)
            }
            disabled={tncNoAccess}
            checked={tncNoAccess ? false : (userInput.save_company_profile === true ? true : false)}
          />
          <label htmlFor="save_profile_cb" className={`${styles.save_profile_label} ${tncNoAccess ? styles.save_profile_label_disabled : styles.save_profile_label_enabled}`}>Save in Company Profile</label>
        </div>
      ) : null}
      {
        <center
          className={`row ${editMode ? styles.submit_center_hidden : styles.submit_center}`}
        >
          <button
            ref={tncRef}
            onClick={(e) => submithandler()}
            className={`btn btn-sm btn-primary ${classes["s-r"]}`}
          >
            {saveButtonText}
          </button>
        </center>
      }
    </div>
  );
};

export default RatingsandFeedback;
